import { render, staticRenderFns } from "./OrderListCanceled.vue?vue&type=template&id=4e311c39"
import script from "./OrderListCanceled.vue?vue&type=script&lang=ts"
export * from "./OrderListCanceled.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports